import { render } from "./WisdomCommunityScreen.vue?vue&type=template&id=6f7c64f7&scoped=true"
import script from "./WisdomCommunityScreen.vue?vue&type=script&lang=js"
export * from "./WisdomCommunityScreen.vue?vue&type=script&lang=js"

import "./WisdomCommunityScreen.vue?vue&type=style&index=0&id=6f7c64f7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f7c64f7"]])

export default __exports__